/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateFileInput = {
    ids?: Array<string | null> | null | undefined;
    name?: string | null | undefined;
    taskId?: string | null | undefined;
    projectId?: string | null | undefined;
    folderId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateFileMutationModernMutationVariables = {
    input: UpdateFileInput;
};
export type updateFileMutationModernMutationResponse = {
    readonly updateFile: {
        readonly files: ReadonlyArray<{
            readonly name: string | null;
            readonly folder: {
                readonly id: string;
                readonly name: string | null;
            } | null;
            readonly task: {
                readonly id: string;
                readonly name: string | null;
                readonly companyTaskId: number | null;
            } | null;
        } | null> | null;
    } | null;
};
export type updateFileMutationModernMutation = {
    readonly response: updateFileMutationModernMutationResponse;
    readonly variables: updateFileMutationModernMutationVariables;
};



/*
mutation updateFileMutationModernMutation(
  $input: UpdateFileInput!
) {
  updateFile(input: $input) {
    files {
      name
      folder {
        id
        name
      }
      task {
        id
        name
        companyTaskId
      }
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateFileInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Folder",
  "kind": "LinkedField",
  "name": "folder",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyTaskId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateFileMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFilePayload",
        "kind": "LinkedField",
        "name": "updateFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "files",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateFileMutationModernMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateFilePayload",
        "kind": "LinkedField",
        "name": "updateFile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "files",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateFileMutationModernMutation",
    "operationKind": "mutation",
    "text": "mutation updateFileMutationModernMutation(\n  $input: UpdateFileInput!\n) {\n  updateFile(input: $input) {\n    files {\n      name\n      folder {\n        id\n        name\n      }\n      task {\n        id\n        name\n        companyTaskId\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '6b34ae75bdc3c8c03a0106f3b927f7fa';
export default node;
